<!--
 * @Author: your name
 * @Date: 2019-11-14 10:15:22
 * @LastEditTime: 2020-12-28 18:01:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fontend_old_wap\src\pages\user\mynews\news.vue
-->
<template>
  <div class="news">
    <!-- <top-nav ref="TopNav"></top-nav>
    <van-nav-bar :title="datas.title" fixed left-arrow @click-left="goBack" @click-right="onClickRight">
      <van-icon slot="right" class="iconfont icon-zhankai"></van-icon>
    </van-nav-bar> -->
    <GlobTopNav :title="datas.title"></GlobTopNav>

    <div class="van-content">
      <div class="newsbox">
        <div v-html="datas.content"></div>
        <div class="time">{{ time(datas.add_time) }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/topnav'
export default {
  name: 'mynews',
  components: {
    TopNav
  },
  data() {
    return {
      datas: [],
      article_id: this.$route.query.article_id,
      notice_id: this.$route.query.notice_id
    }
  },
  methods: {
    goBack: function () {
      history.back(-1)
    },
    onClickRight() {
      this.$refs.TopNav.topnavPlay()
    },
    time: function (timestamp) {
      var date = new Date(timestamp * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = date.getDate() + ' '
      var h = date.getHours() + ':'
      var m = date.getMinutes() + ':'
      var s
      if (date.getSeconds() < 10) {
        s = '0' + date.getSeconds()
      } else {
        s = date.getSeconds()
      }
      return Y + M + D
    }
  },
  mounted() {
    var isUser = localStorage.getItem('BLHuser')
    var mallid = localStorage.getItem('mallid')
    if (this.$route.query.article_id) {
      this.$api.post(
        '/article/detail',
        {
          token_user: isUser,
          id_example: mallid,
          article_id: this.article_id
        },
        res => {
          this.datas = res.data.data
        }
      )
    } else if (this.$route.query.notice_id) {
      this.$api.post(
        '/notice/detail',
        {
          token_user: isUser,
          id_example: mallid,
          notice_id: this.notice_id
        },
        res => {
          this.datas = res.data.data
        }
      )
    }
    // this.datas=JSON.parse(localStorage.getItem('WZ'))
  }
}
</script>

<style lang="less">
.news {
  min-height: 100vh;
  box-sizing: border-box;
  .time {
    text-align: right;
    margin-top: 0.4rem;
  }
  .van-content {
    padding: 0.3rem;
    
    .newsbox {
      background: #fff;
      border-radius: 0.12rem;
      padding: 0.2rem;
    }
  }
  table {
    border-top: 0.02rem solid #ccc;
    border-left: 0.02rem solid #ccc;
    th {
      border-bottom: 0.02rem solid #ccc;
      border-right: 0.02rem solid #ccc;
      text-align: center;
    }
    td {
      border-bottom: 0.02rem solid #ccc;
      border-right: 0.02rem solid #ccc;
      padding: 0.06rem 0.1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/mynews/news.vue